import React, { Component } from 'react';

import { functions } from 'firebase';

import { Alert, Row, Col, Button, Breadcrumb, BreadcrumbItem, Label } from 'reactstrap';
import { AvForm, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';

import PropTypes from 'prop-types';
import Loader from 'components/loader/loader.js';

import ButtonWithLoader from 'components/buttonWithLoader/buttonWithLoader';

class Settings extends Component {
  constructor(props, context) {
    super(props);

    this.state = {
      accountEnabled: true,
      isLoading: true,
      areBusinessSettingsUpdating: false,
      accountStatus: "enabled",
      businessName: this.props.location.state ? this.props.location.state.businessName : null,
      isUnauthorised: false,
    };

    this.handleAccountUpdate = this.handleAccountUpdate.bind(this);
  }

  async componentDidMount() {
    document.title = "Edit business - Bamboo Admin";

    const getBusiness = functions().httpsCallable('getBusiness');

    try {
      let business = (await getBusiness({ businessId: this.props.match.params.businessId })).data.business;
      let accountStatus = business.disabled ? "disabled" : "enabled";

      this.setState({
        isLoading: false,
        billingSchedule: business.batchSetting,
        accountStatus: accountStatus,
      });
    } catch (error) {
      if (error.code === 'unauthenticated') {
        this.setState({ isUnauthorised: true, isLoading: false });
      } else {
        this.setState({ isLoading: false });
      }
    }

    if (!this.state.businessName) {
      this.getBusinessDisplayName();
    }
  }

  async getBusinessDisplayName() {
    const getBusinessDisplayName = functions().httpsCallable('getBusinessDisplayName');

    try {
      let businessName = (await getBusinessDisplayName({ businessId: this.props.match.params.businessId })).data;
      this.setState({ businessName: businessName });
    } catch (error) {
      console.error(error);
    }
  }

  async handleAccountUpdate(event, values) {
    const updateBusinessSettings = functions().httpsCallable('updateBusinessSettings');

    try {
      this.setState({ areBusinessSettingsUpdating: true });

      let disabledValue;

      if (values.accountStatus === "enabled") {
        disabledValue = false;
      } else {
        disabledValue = true;
      }

      await updateBusinessSettings({ businessId: this.props.match.params.businessId, isDisabled: disabledValue, billingSchedule: values.billingSchedule });

      this.setState({
        successMessage: "Account settings updated",
        successMessageVisible: true,
        areBusinessSettingsUpdating: false,
      });
    } catch (error) {
      console.error(error);

      this.setState({
        areBusinessSettingsUpdating: false,
        errorMessageVisible: true,
        errorMessage: error.message,
      });
    }
  }

  handleSuccessDismiss = () => {
    this.setState({ successMessageVisible: false });
  }


  handleErrorDismiss() {
    this.setState({ errorMessageVisible: false });
  }

  render() {
    const breadcrumb = (
      <Breadcrumb className="themed-breadcrumb">
        {/* this is an anchor tag as admin is not within our react router */}
        <BreadcrumbItem><a href="/admin">Home</a></BreadcrumbItem>
        <BreadcrumbItem onClick={() => this.props.history.push(`/admin/businesses`)}>Businesses List</BreadcrumbItem>
        <BreadcrumbItem active>{this.state.businessName}</BreadcrumbItem>
      </Breadcrumb>
    );

    const header = (
      <Col sm={{ size: 12, offset: 0 }} className="mt-2 mb-4 text-center">
        <p><span className="branded-word settings-tagline">Editing Business Account</span></p>

        <div style={{ "margin": "0 auto", "display": "inline-block" }}>
          {breadcrumb}
        </div>
      </Col>
    );

    const successDisplay = (
      this.state.successMessageVisible &&
      (
        <Alert className="small-text" color="success" isOpen={this.state.successMessageVisible} toggle={this.handleSuccessDismiss}>
          {this.state.successMessage}
        </Alert>
      )
    );

    const errorDisplay = (
      this.state.errorMessageVisible &&
      (
        <Alert className="small-text" color="danger" isOpen={this.state.errorMessageVisible} toggle={this.handleErrorDismiss}>
          {this.state.errorMessage}
        </Alert>
      )
    );

    const settingsUI = (
      <Col sm={{ size: 6, offset: 3 }} className="business-signup-form">
        <Row>
          <Col sm={{ size: 6 }} className="divider-right" style={{ "borderRight": "2px solid #f9f9fa" }}>
            <AvForm onValidSubmit={this.handleAccountUpdate}>
              <h5>Account settings:</h5>

              <AvRadioGroup inline className="mb-4" name="accountStatus" value={this.state.accountStatus} errorMessage="Pick one!" required>
                <Label>Account status:</Label>
                <br />
                <AvRadio label="Enabled" value="enabled" />
                <AvRadio label="Disabled" value="disabled" />
              </AvRadioGroup>

              <AvRadioGroup inline className="mb-4" name="billingSchedule" value={this.state.billingSchedule} errorMessage="Pick one!" required>
                <Label>Billing schedule:</Label>
                <br />
                <AvRadio label="Per Transaction" value="perTransaction" />
                <AvRadio label="Daily" value="daily" />
                <AvRadio label="Weekly" value="weekly" />
              </AvRadioGroup>

              <ButtonWithLoader
                display={this.state.areBusinessSettingsUpdating}
                buttonText="Save changes"
              />

              <br />
              {successDisplay}
              {errorDisplay}
            </AvForm>
          </Col>

          <Col sm={{ size: 6 }}>
            <div>
              <h5>Account information:</h5>

              <a target="_blank" rel="noopener noreferrer" href={`/business/${this.props.match.params.businessId}/credit/`}>
                <Button color="primary" className="float-left btn">See credits</Button>
              </a>
            </div>
          </Col>
        </Row>
      </Col>
    );

    const loadingUI = (
      <div className="text-center offset-md-4 col-md-4">
        <Loader loading={this.state.isLoading} />
      </div>
    );

    const notAuthorisedUI = (
      <Col sm={{ size: 4, offset: 4 }} className="dashboard-panel business-signup-form enable-scroll">
        <h4>Error: Account not authorised</h4>
        <p>The account you're signed in with is not authorised to access this page. <a href="/admin">Click here</a> to sign in</p>
      </Col>
    );

    return (
      <Row>
        {header}

        {
          this.state.isLoading
            ? loadingUI
            : this.state.isUnauthorised
              ? notAuthorisedUI
              : settingsUI
        }

      </Row>
    );
  }
}

Settings.contextTypes = {
  authUser: PropTypes.object,
  userId: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default Settings;
